import { Point2D, Point3D } from './point.types';

export const GEO_TOLERANCE = 1e-6;

export const geoValuesEqual = (
  val1: number,
  val2: number,
  tolerance = GEO_TOLERANCE
): boolean => {
  return Math.abs(val1 - val2) <= tolerance;
};

export const arePointsEqual = <T extends Point2D | Point3D>(
  p1: T | null,
  p2: T | null,
  tolerance = GEO_TOLERANCE
): boolean => {
  if (!p1 || !p2) return false;

  if ('z' in p1) {
    return (
      geoValuesEqual(p1.x, p2.x, tolerance) &&
      geoValuesEqual(p1.y, p2.y, tolerance) &&
      geoValuesEqual(p1.z, (p2 as Point3D).z, tolerance)
    );
  }

  return (
    geoValuesEqual(p1.x, p2.x, tolerance) &&
    geoValuesEqual(p1.y, p2.y, tolerance)
  );
};

export const isPointZero = (
  point: Point3D,
  tolerance = GEO_TOLERANCE
): boolean => {
  return arePointsEqual(point, { x: 0, y: 0, z: 0 }, tolerance);
};

export const calculateCenterFromPointArray = (
  centers: Point2D[]
): Point2D | undefined => {
  if (centers.length === 0) return undefined;

  const sum = centers.reduce(
    (acc, center) => {
      acc.x += center.x;
      acc.y += center.y;
      return acc;
    },
    { x: 0, y: 0 }
  );

  return { x: sum.x / centers.length, y: sum.y / centers.length };
};
